import { Pipe, PipeTransform } from '@angular/core';
import { AvailableUsersModel } from 'src/app/lobby/lobby-staff-status/shared/models/impersonate-assist-detail.model';

@Pipe({
    name: 'impersonationtransferfilter',
    pure: false
})
export class ImpersonationTransferOptionFilterPipe implements PipeTransform {
    transform(items: AvailableUsersModel[], impersonatedByUserId: number): any {
        if (!items) {
            return items;
        }
        // filter items array, items which match and return true will be
        // kept, false will be filtered out
        return items.filter(item => item.availableImpersonateAssistCount > 0 || item.userId == impersonatedByUserId);
    }
}